export default {
  password: {
    minLength: 'Hasło powinno zawierać min. 10',
    containsNumbers: 'znaków i min. 1 cyfrę.',
    general: 'Hasło musi mieć min. 10 znaków, zawierać co najmniej 1 małą i 1 wielką literę, 1 cyfrę oraz 1 znak specjalny.',
    required: 'Hasło jest wymagane.',
    same: 'Wprowadzone hasła różnią się.',
  },
  email: {
    required: 'E-mail jest wymagany.',
    notValid: 'E-mail jest niepoprawny.',
  },
};
